query GetSelectableCustomFields($input: CustomFieldsInput!) {
    customFields(input: $input) {
        active {
            id
            attribute {
                name
                displayType
            }
        }
    }
}
